import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import styles from './styles';
import { ActivationMapDetails } from './ActivationMapDetails';
import { AppState } from '../../redux/store';
import { selectActivationLogsDetails } from '../../redux/selectors/hubs';
import { getHubActivityLogsDetailsRequest } from '../../redux/actions/hubs/hubs';

const mapStateToProps = (state: AppState) => ({
  activationLogsDetails: selectActivationLogsDetails(state),
});

const mapDispatchToProps = {
  loadActivationLogsDetails: getHubActivityLogsDetailsRequest,
};

export default withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(ActivationMapDetails));
